import type { Component } from 'vue';

export interface FieldComponentResolver {
    register(kind: string, component: Component): void;
    resolve(kind: string): Component | undefined;
}

export const createFieldComponentResolver = (): FieldComponentResolver => {
    const components = new Map<string, Component>();

    return {
        register(kind, component) {
            components.set(kind, component);
        },
        resolve(kind) {
            return components.get(kind);
        }
    };
};
